import { CdkStore } from 'drive-ui-packages';
import { UserDepartmentDetails } from 'adapters/types/UserData';
import { DropdownOption } from './types';

export const getDropDownOptions = (
  stores: CdkStore[],
  departments: UserDepartmentDetails[]
): DropdownOption[] =>
  stores.map(({ storeId, name, defaultStore }) => {
    const companyId = departments.find(
      dept => dept.storeId === storeId
    )?.companyId;
    return {
      label: companyId ? `${companyId} - ${name}` : name,
      value: storeId,
      'data-testid': defaultStore
        ? `${storeId}-option-${defaultStore.toString()}`
        : `${storeId}-option`
    };
  });
